import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import useEvents from "./useEvents";
import Emitter from "../Emitter";

/**
 * Shared sign-out for coach console: clears storage, query cache, org listeners, Firebase session.
 */
export default function useCoachSignOut() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const events = useEvents();

  return useCallback(
    async (methodType) => {
      try {
        localStorage.removeItem("uid");
        localStorage.removeItem("email");
        localStorage.removeItem("organizationId");
        localStorage.removeItem("credentials.user.uid");
        queryClient.clear();
        Emitter.removeAllListeners("orgChanged");
        events.logSignout({ method: methodType });
        await firebase.auth().signOut();
        navigate("/signin");
      } catch (error) {
        console.error("Error during sign out:", error);
        navigate("/signin");
      }
    },
    [navigate, queryClient, events],
  );
}
